import { filter, map } from 'rxjs/operators';
import createEventContext from '@clearscore/helpers.create-event-context';
import interpolateValues from '@clearscore/helpers.interpolate-values';

/**
 * Factory method returning a segment transformer
 * @param {Observable} state$ redux state
 * @returns {(event$: Observable) => Observable} segment$ observable
 */
const createSegmentTransformer = (state$) => (event$) =>
    event$.pipe(
        filter((event) => event.providers && event.providers.segment),
        map((event) => {
            const context = (event.payload && event.payload.context) || {};
            const eventContext = createEventContext({ context });
            const eventDictionary = event.dictionary || {};

            return {
                ...event.providers.segment,
                props: interpolateValues(state$.value, event.providers.segment.props, {
                    ...eventDictionary,
                    ...eventContext,
                }),
                ...(event.providers.segment.traits
                    ? {
                          traits: interpolateValues(state$.value, event.providers.segment.traits, {
                              ...eventDictionary,
                              ...eventContext,
                          }),
                      }
                    : {}),
            };
        }),
    );

export default createSegmentTransformer;
